/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * eeelt前后端API说明文档
 * OpenAPI spec version: 1.0
 */
export interface UpdateSchoolGamificationRequest {
  schoolId: number;
  gamificationEnabled: boolean;
  leaderboardEnabled?: boolean;
}

/**
 * 封装通用字段的响应
 */
export interface EltResponseBoolean {
  /** 业务响应码 */
  code: number;
  /** 响应信息 */
  message: string;
  /** 响应数据 */
  data?: boolean;
  /** 请求时间戳，用于定位问题 */
  timestamp?: string;
}

export interface UpdateGamificationConfigRequest {
  id: number;
  configValue?: string;
  description?: string;
}

export interface SendResetPasswordRequest {
  t?: string;
}

export interface ResetPasswordRequest {
  token?: string;
  salt?: string;
  password?: string;
}

export interface RequestVerificationRequest {
  t?: string;
}

export interface TeacherCreateRequest {
  name: string;
  nameEn?: string;
  schoolName: string;
  email: string;
  password: string;
  salt: string;
  sex: string;
  avatar?: string;
  signature?: string;
  captcha: string;
}

/**
 * 封装通用字段的响应
 */
export interface EltResponseUserInfoResponse {
  /** 业务响应码 */
  code: number;
  /** 响应信息 */
  message: string;
  data?: UserInfoResponse;
  /** 请求时间戳，用于定位问题 */
  timestamp?: string;
}

export type UserInfoResponseRole =
  (typeof UserInfoResponseRole)[keyof typeof UserInfoResponseRole];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UserInfoResponseRole = {
  TEACHER: "TEACHER",
  STUDENT: "STUDENT",
} as const;

/**
 * 响应数据
 */
export interface UserInfoResponse {
  role: UserInfoResponseRole;
  id: number;
  email: string;
  avatar: string;
  signature: string;
  name: string;
  schoolName: string;
  sex: string;
  registeredAt: string;
  nameEn?: string;
}

export interface StudentCreateRequest {
  name: string;
  nameEn?: string;
  classNumber?: number;
  schoolNumber?: number;
  gradeLevel?: number;
  schoolName: string;
  email: string;
  password: string;
  salt: string;
  sex: string;
  avatar?: string;
  signature?: string;
  captcha: string;
  strn?: string;
}

/**
 * 封装通用字段的响应
 */
export interface EltResponseStudentInfoResponse {
  /** 业务响应码 */
  code: number;
  /** 响应信息 */
  message: string;
  data?: StudentInfoResponse;
  /** 请求时间戳，用于定位问题 */
  timestamp?: string;
}

export type StudentInfoResponseRole =
  (typeof StudentInfoResponseRole)[keyof typeof StudentInfoResponseRole];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const StudentInfoResponseRole = {
  TEACHER: "TEACHER",
  STUDENT: "STUDENT",
} as const;

/**
 * 响应数据
 */
export interface StudentInfoResponse {
  role: StudentInfoResponseRole;
  id: number;
  email: string;
  avatar: string;
  signature: string;
  name: string;
  schoolName: string;
  sex: string;
  registeredAt: string;
  nameEn?: string;
  studentReferenceNumber: string;
  gradeLevel?: number;
}

/**
 * 登陆请求头
 */
export interface LoginRequest {
  /** 用户email */
  email: string;
  /** 用户密码 */
  password: string;
}

/**
 * 封装通用字段的响应
 */
export interface EltResponseLoginResponse {
  /** 业务响应码 */
  code: number;
  /** 响应信息 */
  message: string;
  data?: LoginResponse;
  /** 请求时间戳，用于定位问题 */
  timestamp?: string;
}

/**
 * 响应数据
 */
export interface LoginResponse {
  token: string;
  user: UserInfoResponse;
}

export interface SubmitSurveyRequest {
  userId: number;
  userType: number;
  surveyId: number;
  startTime: string;
  submitTime: string;
  items: SurveyItem[];
}

export interface SurveyItem {
  questionId: number;
  answer: string;
  answerAt: string;
}

export interface UpdateShareRequest {
  assignmentId: number;
  granteeIds: number[];
}

/**
 * 响应数据
 */
export type EltResponseVoidData = { [key: string]: unknown };

/**
 * 封装通用字段的响应
 */
export interface EltResponseVoid {
  /** 业务响应码 */
  code: number;
  /** 响应信息 */
  message: string;
  /** 响应数据 */
  data?: EltResponseVoidData;
  /** 请求时间戳，用于定位问题 */
  timestamp?: string;
}

/**
 * Submit self-assessment request
 */
export interface SubmitSelfAssessmentRequest {
  /** Assignment stat ID */
  assignmentStatId: number;
  /** Opaque client-generated trace ID; not security-sensitive; for forensic correlation only. */
  answerSessionId?: string;
}

/**
 * 封装通用字段的响应
 */
export interface EltResponseSelfAssessmentResultResponse {
  /** 业务响应码 */
  code: number;
  /** 响应信息 */
  message: string;
  data?: SelfAssessmentResultResponse;
  /** 请求时间戳，用于定位问题 */
  timestamp?: string;
}

/**
 * 响应数据
 */
export interface SelfAssessmentResultResponse {
  pointsAwardedKp?: number;
  pointsAwardedGs?: number;
}

/**
 * Appeal resolution request
 */
export interface AppealResolveRequest {
  /** Whether the appeal is approved */
  approved: boolean;
}

/**
 * 响应数据
 */
export interface AppealDetailResponse {
  approved?: boolean;
  pointsAwarded?: number;
}

/**
 * 封装通用字段的响应
 */
export interface EltResponseAppealDetailResponse {
  /** 业务响应码 */
  code: number;
  /** 响应信息 */
  message: string;
  data?: AppealDetailResponse;
  /** 请求时间戳，用于定位问题 */
  timestamp?: string;
}

/**
 * Appeal submission request
 */
export interface AppealSubmitRequest {
  /** Assignment stat ID */
  assignmentStatId: number;
  /** Student's reasoning for appeal */
  reasoning: string;
}

export interface SubmitPulseItemRequest {
  studentId?: number;
  assignmentId?: number;
  type?: string;
  itemId?: string;
  rating?: number;
}

/**
 * 封装通用字段的响应
 */
export interface EltResponseString {
  /** 业务响应码 */
  code: number;
  /** 响应信息 */
  message: string;
  /** 响应数据 */
  data?: string;
  /** 请求时间戳，用于定位问题 */
  timestamp?: string;
}

/**
 * 封装通用字段的响应
 */
export interface EltResponseListString {
  /** 业务响应码 */
  code: number;
  /** 响应信息 */
  message: string;
  /** 响应数据 */
  data?: string[];
  /** 请求时间戳，用于定位问题 */
  timestamp?: string;
}

export interface DeleteQuestionInfoRequest {
  questionInfoId: number;
}

/**
 * 响应数据
 */
export interface CreateQuestionInfoResponse {
  id: number;
}

/**
 * 封装通用字段的响应
 */
export interface EltResponseCreateQuestionInfoResponse {
  /** 业务响应码 */
  code: number;
  /** 响应信息 */
  message: string;
  data?: CreateQuestionInfoResponse;
  /** 请求时间戳，用于定位问题 */
  timestamp?: string;
}

export interface CreateLabelRequest {
  name: string;
  type: string;
  description?: string;
}

/**
 * 响应数据
 */
export interface CreateLabelResponse {
  id: number;
}

/**
 * 封装通用字段的响应
 */
export interface EltResponseCreateLabelResponse {
  /** 业务响应码 */
  code: number;
  /** 响应信息 */
  message: string;
  data?: CreateLabelResponse;
  /** 请求时间戳，用于定位问题 */
  timestamp?: string;
}

/**
 * Text2SQL chat request
 */
export interface Text2SqlRequest {
  /** Natural language question about student learning insights */
  message?: string;
  /** Session ID for conversation history continuity */
  sessionId?: string;
}

/**
 * 封装通用字段的响应
 */
export interface EltResponseText2SqlResponse {
  /** 业务响应码 */
  code: number;
  /** 响应信息 */
  message: string;
  data?: Text2SqlResponse;
  /** 请求时间戳，用于定位问题 */
  timestamp?: string;
}

/**
 * Query result data rows
 */
export type Text2SqlResponseDataItem = {
  [key: string]: { [key: string]: unknown };
};

/**
 * Text2SQL chat response
 */
export interface Text2SqlResponse {
  /** Whether the query was processed successfully */
  success?: boolean;
  /** Response type: 'result', 'clarification', or 'error' */
  type?: string;
  /** Generated SQL query (if applicable) */
  sql?: string;
  /** Query result data rows */
  data?: Text2SqlResponseDataItem[];
  /** Column names from query result */
  columns?: string[];
  /** Number of rows returned */
  rowCount?: number;
  /** Natural language summary of results */
  summary?: string;
  /** Message for clarification or error */
  message?: string;
  /** Validation pipeline steps for debugging */
  validationSteps?: ValidationStep[];
}

/**
 * Validation pipeline steps for debugging
 */
export interface ValidationStep {
  step?: string;
  status?: string;
  detail?: string;
}

export interface ChangedStudent {
  studentId?: number;
  studentName?: string;
  schoolName?: string;
  oldKpAllTime?: number;
  oldGsAllTime?: number;
  oldKpCurrentMonth?: number;
  oldGsCurrentMonth?: number;
  newKpAllTime?: number;
  newGsAllTime?: number;
  newKpCurrentMonth?: number;
  newGsCurrentMonth?: number;
}

/**
 * 封装通用字段的响应
 */
export interface EltResponseRecalculateScoresResponse {
  /** 业务响应码 */
  code: number;
  /** 响应信息 */
  message: string;
  data?: RecalculateScoresResponse;
  /** 请求时间戳，用于定位问题 */
  timestamp?: string;
}

/**
 * 响应数据
 */
export interface RecalculateScoresResponse {
  totalStudents?: number;
  changedStudents?: number;
  changes?: ChangedStudent[];
}

export interface ArchiveStudentRecordsRequest {
  emails: string[];
}

/**
 * 响应数据
 */
export interface ArchiveDuplicateRewardsResponse {
  groupsProcessed?: number;
  recordsArchived?: number;
  studentsAffected?: number;
  overCapGroupsProcessed?: number;
  overCapRecordsArchived?: number;
  overCapStudentsAffected?: number;
}

/**
 * 封装通用字段的响应
 */
export interface EltResponseArchiveDuplicateRewardsResponse {
  /** 业务响应码 */
  code: number;
  /** 响应信息 */
  message: string;
  data?: ArchiveDuplicateRewardsResponse;
  /** 请求时间戳，用于定位问题 */
  timestamp?: string;
}

/**
 * 封装通用字段的响应
 */
export interface EltResponseInteger {
  /** 业务响应码 */
  code: number;
  /** 响应信息 */
  message: string;
  /** 响应数据 */
  data?: number;
  /** 请求时间戳，用于定位问题 */
  timestamp?: string;
}

export interface SubmitAnnotationRequest {
  taskId?: number;
  selectedCandidateId?: number;
  reason?: string;
}

export interface ClassroomUpdateStudentsRequest {
  classroomInfoId?: number;
  studentIds?: number[];
}

export interface ClassroomRegisterRequest {
  name: string;
  schoolName: string;
  grade?: number;
  override?: boolean;
}

/**
 * 响应数据
 */
export interface ClassroomRegisterResponse {
  id: number;
}

/**
 * 封装通用字段的响应
 */
export interface EltResponseClassroomRegisterResponse {
  /** 业务响应码 */
  code: number;
  /** 响应信息 */
  message: string;
  data?: ClassroomRegisterResponse;
  /** 请求时间戳，用于定位问题 */
  timestamp?: string;
}

export interface RegisterStudentsRequest {
  studentInfos: StudentCreateRequest[];
  classroomInfoIds: number[];
}

export interface ClassroomEditRequest {
  id?: number;
  name: string;
  grade?: number;
}

/**
 * 响应数据
 */
export type EltResponseObjectData = { [key: string]: unknown };

/**
 * 封装通用字段的响应
 */
export interface EltResponseObject {
  /** 业务响应码 */
  code: number;
  /** 响应信息 */
  message: string;
  /** 响应数据 */
  data?: EltResponseObjectData;
  /** 请求时间戳，用于定位问题 */
  timestamp?: string;
}

export interface DeleteClassRequest {
  id: number;
}

export interface ClassroomCreateRequest {
  classroomInfoId: number;
  classroomType?: number;
  subject: string;
  subjectId: number;
  teacherId: number;
}

/**
 * 响应数据
 */
export interface ClassroomCreateResponse {
  sessionId: string;
}

/**
 * 封装通用字段的响应
 */
export interface EltResponseClassroomCreateResponse {
  /** 业务响应码 */
  code: number;
  /** 响应信息 */
  message: string;
  data?: ClassroomCreateResponse;
  /** 请求时间戳，用于定位问题 */
  timestamp?: string;
}

/**
 * 封装通用字段的响应
 */
export interface EltResponseSubmitAnswerResponse {
  /** 业务响应码 */
  code: number;
  /** 响应信息 */
  message: string;
  data?: SubmitAnswerResponse;
  /** 请求时间戳，用于定位问题 */
  timestamp?: string;
}

export interface PointAwardInfo {
  currencyType?: string;
  amount?: number;
  eventType?: string;
  description?: string;
}

/**
 * 响应数据
 */
export interface SubmitAnswerResponse {
  success?: boolean;
  pointAwards?: PointAwardInfo[];
  totalKp?: number;
  totalGs?: number;
}

export interface SetStudentMessageRequest {
  studentMessage: StudentMessage;
}

export interface StudentMessage {
  id?: number;
  title?: string;
  description?: string;
  replyType?: number;
  teacherMessage?: string;
  studentId?: number;
  studentName?: string;
  teacherId?: number;
  teacherName?: string;
  questionInfoId?: number;
  questionId?: number;
  createdAt?: string;
  type?: number;
}

export interface SetSelfAssessmentResultRequest {
  assignmentId: number;
  studentId: number;
  resultJson?: string;
}

export interface Question {
  id?: number;
  assignmentId?: number;
  teacherId?: number;
  studentId?: number;
  questionInfoId?: number;
  answer?: string;
  isCorrectAnswer?: boolean;
  errorPoints?: string;
  isCompleted?: boolean;
  metaAnswer?: string;
  aiReview?: string;
  submitedAt?: string;
  createdAt?: string;
  teacherReview?: string;
  filesJson?: string;
  archived?: boolean;
  draft?: string;
  answerDurationInSecond?: number;
  originalIsCorrect?: boolean;
  requestAnswer?: boolean;
  correctionCount?: number;
  lastCorrectedAt?: string;
  correctionKpAwarded?: number;
  correctionGsAwarded?: number;
}

export interface SetBookmarkRequest {
  studentId?: number;
  question?: Question;
  isMarked?: boolean;
  noteText?: string;
}

export interface PublishAssignmentRequest {
  title: string;
  description?: string;
  type: string;
  teacherId?: number;
  classInfoId?: number;
  classSessionId?: string;
  quizId: number;
  dueDate?: string;
  studentId?: number;
  topicIds: number[];
}

/**
 * 封装通用字段的响应
 */
export interface EltResponseLong {
  /** 业务响应码 */
  code: number;
  /** 响应信息 */
  message: string;
  /** 响应数据 */
  data?: number;
  /** 请求时间戳，用于定位问题 */
  timestamp?: string;
}

export interface EditQuizRequest {
  quizId: number;
  questionInfoIds: number[];
}

export interface EditAssignmentRequest {
  id: number;
  title?: string;
  description?: string;
  quizId?: number;
  dueDate?: string;
}

export interface DeleteAssignmentRequest {
  assignmentId: number;
}

export interface CreateQuizRequest {
  title: string;
  description?: string;
  subject: string;
  subjectId: number;
  originName: string;
  originType: string;
  language: string;
  teacher_id: number;
  topicIds: number[];
  questionInfoIds: number[];
}

/**
 * 响应数据
 */
export interface CreateQuizResponse {
  id: number;
}

/**
 * 封装通用字段的响应
 */
export interface EltResponseCreateQuizResponse {
  /** 业务响应码 */
  code: number;
  /** 响应信息 */
  message: string;
  data?: CreateQuizResponse;
  /** 请求时间戳，用于定位问题 */
  timestamp?: string;
}

export interface RemarkAnswerRequest {
  question: string;
  standardAnswer?: string;
  answer: string;
  questionId?: number;
  showTips?: boolean;
  chatId?: string;
}

/**
 * 封装通用字段的响应
 */
export interface EltResponseRemarkAnswerResponse {
  /** 业务响应码 */
  code: number;
  /** 响应信息 */
  message: string;
  data?: RemarkAnswerResponse;
  /** 请求时间戳，用于定位问题 */
  timestamp?: string;
}

/**
 * 响应数据
 */
export interface RemarkAnswerResponse {
  results: RemarkAnswerResult[];
  rawText: string;
}

export interface RemarkAnswerResult {
  isCorrect?: boolean;
  methodSuitable?: boolean;
  hintsIfNotCorrect?: string;
  errorType?: string;
}

export interface QuestionData {
  question?: string;
  answer?: string;
  questionEn?: string;
  answerEn?: string;
  apiId?: string;
}

export interface RecordQuestionChoiceRequest {
  teacherId: number;
  grade?: number;
  subject?: string;
  subjectId: number;
  difficulty?: number;
  language?: string;
  questionType?: string;
  topicId?: number;
  topicName?: string;
  knowledgePointIds?: string;
  questionA?: QuestionData;
  questionB?: QuestionData;
  selectedQuestion: string;
}

export interface RecordHintStepRequest {
  aiUsageId: number;
}

export interface GetHomeworkSummaryRequest {
  chatId: string;
  data: string;
}

/**
 * 封装通用字段的响应
 */
export interface EltResponseGetHomeworkSummaryResponse {
  /** 业务响应码 */
  code: number;
  /** 响应信息 */
  message: string;
  data?: GetHomeworkSummaryResponse;
  /** 请求时间戳，用于定位问题 */
  timestamp?: string;
}

/**
 * 响应数据
 */
export interface GetHomeworkSummaryResponse {
  summary: string;
}

export interface GetAnswerTipsRequest {
  chatId: string;
  question: string;
  standardAnswer?: string;
  answer: string;
  questionId?: number;
  assignmentId?: number;
}

/**
 * 封装通用字段的响应
 */
export interface EltResponseGetAnswerTipsResponse {
  /** 业务响应码 */
  code: number;
  /** 响应信息 */
  message: string;
  data?: GetAnswerTipsResponse;
  /** 请求时间戳，用于定位问题 */
  timestamp?: string;
}

/**
 * 响应数据
 */
export interface GetAnswerTipsResponse {
  tips: string;
  aiUsageId?: number;
}

export interface GenerateQuestionRequest {
  chatId: string;
  prompt: string;
}

/**
 * 封装通用字段的响应
 */
export interface EltResponseGenerateQuestionResponse {
  /** 业务响应码 */
  code: number;
  /** 响应信息 */
  message: string;
  data?: GenerateQuestionResponse;
  /** 请求时间戳，用于定位问题 */
  timestamp?: string;
}

/**
 * 响应数据
 */
export interface GenerateQuestionResponse {
  question?: string;
  answer?: string;
  questionEn?: string;
  answerEn?: string;
}

export type AssistantMessageMessageType =
  (typeof AssistantMessageMessageType)[keyof typeof AssistantMessageMessageType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AssistantMessageMessageType = {
  USER: "USER",
  ASSISTANT: "ASSISTANT",
  SYSTEM: "SYSTEM",
  TOOL: "TOOL",
} as const;

export type AssistantMessageMetadata = {
  [key: string]: { [key: string]: unknown };
};

export interface AssistantMessage {
  messageType?: AssistantMessageMessageType;
  metadata?: AssistantMessageMetadata;
  toolCalls?: ToolCall[];
  media?: Media[];
  text?: string;
}

export interface ChatGenerationMetadata {
  empty?: boolean;
  contentFilters?: string[];
  finishReason?: string;
}

export interface ChatResponse {
  result?: Generation;
  results?: Generation[];
  metadata?: ChatResponseMetadata;
}

export interface ChatResponseMetadata {
  id?: string;
  model?: string;
  rateLimit?: RateLimit;
  usage?: Usage;
  promptMetadata?: PromptMetadata;
  empty?: boolean;
}

export interface Generation {
  output?: AssistantMessage;
  metadata?: ChatGenerationMetadata;
}

export type MediaData = { [key: string]: unknown };

export interface Media {
  id?: string;
  mimeType?: MimeType;
  data?: MediaData;
  name?: string;
  dataAsByteArray?: string;
}

export type MimeTypeParameters = { [key: string]: string };

export interface MimeType {
  type?: string;
  subtype?: string;
  parameters?: MimeTypeParameters;
  concrete?: boolean;
  charset?: string;
  wildcardType?: boolean;
  wildcardSubtype?: boolean;
  subtypeSuffix?: string;
}

export interface PromptMetadata {
  [key: string]: unknown;
}

export type RateLimitRequestsResetUnitsItem = {
  dateBased?: boolean;
  timeBased?: boolean;
  durationEstimated?: boolean;
};

export type RateLimitRequestsReset = {
  seconds?: number;
  nano?: number;
  negative?: boolean;
  zero?: boolean;
  units?: RateLimitRequestsResetUnitsItem[];
};

export type RateLimitTokensResetUnitsItem = {
  dateBased?: boolean;
  timeBased?: boolean;
  durationEstimated?: boolean;
};

export type RateLimitTokensReset = {
  seconds?: number;
  nano?: number;
  negative?: boolean;
  zero?: boolean;
  units?: RateLimitTokensResetUnitsItem[];
};

export interface RateLimit {
  requestsLimit?: number;
  requestsRemaining?: number;
  requestsReset?: RateLimitRequestsReset;
  tokensLimit?: number;
  tokensRemaining?: number;
  tokensReset?: RateLimitTokensReset;
}

export interface ToolCall {
  id?: string;
  type?: string;
  name?: string;
  arguments?: string;
}

export type UsageNativeUsage = { [key: string]: unknown };

export interface Usage {
  promptTokens?: number;
  completionTokens?: number;
  totalTokens?: number;
  nativeUsage?: UsageNativeUsage;
}

export interface AskChatbotRequest {
  chatId: string;
  message: string;
  questionId?: number;
  assignmentId?: number;
}

/**
 * 响应数据
 */
export interface AskChatbotResponse {
  message: string;
}

/**
 * 封装通用字段的响应
 */
export interface EltResponseAskChatbotResponse {
  /** 业务响应码 */
  code: number;
  /** 响应信息 */
  message: string;
  data?: AskChatbotResponse;
  /** 请求时间戳，用于定位问题 */
  timestamp?: string;
}

/**
 * 封装通用字段的响应
 */
export interface EltResponseSurveyV2Response {
  /** 业务响应码 */
  code: number;
  /** 响应信息 */
  message: string;
  data?: SurveyV2Response;
  /** 请求时间戳，用于定位问题 */
  timestamp?: string;
}

/**
 * 响应数据
 */
export interface SurveyV2Response {
  hasRecord: boolean;
  submitTime?: string;
}

/**
 * 封装通用字段的响应
 */
export interface EltResponseTeacherListResponse {
  /** 业务响应码 */
  code: number;
  /** 响应信息 */
  message: string;
  data?: TeacherListResponse;
  /** 请求时间戳，用于定位问题 */
  timestamp?: string;
}

export interface TeacherInfo {
  id?: number;
  name?: string;
  email?: string;
}

/**
 * 响应数据
 */
export interface TeacherListResponse {
  teachers?: TeacherInfo[];
}

/**
 * 封装通用字段的响应
 */
export interface EltResponseListShareGranteeResponse {
  /** 业务响应码 */
  code: number;
  /** 响应信息 */
  message: string;
  /** 响应数据 */
  data?: ShareGranteeResponse[];
  /** 请求时间戳，用于定位问题 */
  timestamp?: string;
}

/**
 * 响应数据
 */
export interface ShareGranteeResponse {
  granteeId?: number;
  granteeName?: string;
  granteeEmail?: string;
  sharedAt?: string;
}

/**
 * 响应数据
 */
export interface AppealListResponse {
  appeals?: AssignmentStat[];
}

export interface AssignmentStat {
  id?: number;
  assignmentId?: number;
  mode?: number;
  totalQuestionNum?: number;
  reviewQuestionNum?: number;
  correctQuestionNum?: number;
  createdAt?: string;
  studentId?: number;
  selfAssessmentJson?: string;
  allCorrectOnFirstAttempt?: boolean;
  submittedAt?: string;
  isLateSubmission?: boolean;
  completionDate?: string;
  homeworkPointsAwarded?: boolean;
  correctionPointsAwardedTotal?: number;
  selfAssessmentSubmitted?: boolean;
  selfAssessmentSubmittedAt?: string;
  selfAssessmentAppealPending?: boolean;
}

/**
 * 封装通用字段的响应
 */
export interface EltResponseAppealListResponse {
  /** 业务响应码 */
  code: number;
  /** 响应信息 */
  message: string;
  data?: AppealListResponse;
  /** 请求时间戳，用于定位问题 */
  timestamp?: string;
}

/**
 * 响应数据
 */
export interface CheckPulseItemResponse {
  shouldShow?: boolean;
  type?: string;
  itemId?: string;
}

/**
 * 封装通用字段的响应
 */
export interface EltResponseCheckPulseItemResponse {
  /** 业务响应码 */
  code: number;
  /** 响应信息 */
  message: string;
  data?: CheckPulseItemResponse;
  /** 请求时间戳，用于定位问题 */
  timestamp?: string;
}

/**
 * 封装通用字段的响应
 */
export interface EltResponseGetTopicListResponse {
  /** 业务响应码 */
  code: number;
  /** 响应信息 */
  message: string;
  data?: GetTopicListResponse;
  /** 请求时间戳，用于定位问题 */
  timestamp?: string;
}

/**
 * 响应数据
 */
export interface GetTopicListResponse {
  topicInfos: QuestionLabel[];
}

export interface QuestionLabel {
  id?: number;
  name?: string;
  enName?: string;
  type?: string;
  description?: string;
  mtrId?: string;
  createdAt?: string;
}

/**
 * 封装通用字段的响应
 */
export interface EltResponseGetSubjectListResponse {
  /** 业务响应码 */
  code: number;
  /** 响应信息 */
  message: string;
  data?: GetSubjectListResponse;
  /** 请求时间戳，用于定位问题 */
  timestamp?: string;
}

/**
 * 响应数据
 */
export interface GetSubjectListResponse {
  subjectInfos: QuestionLabel[];
}

/**
 * 封装通用字段的响应
 */
export interface EltResponseGetQuestionListResponse {
  /** 业务响应码 */
  code: number;
  /** 响应信息 */
  message: string;
  data?: GetQuestionListResponse;
  /** 请求时间戳，用于定位问题 */
  timestamp?: string;
}

/**
 * 响应数据
 */
export interface GetQuestionListResponse {
  assignmentId?: number;
  questionModelList: QuestionModel[];
  assignmentStat?: AssignmentStat;
}

export interface QuestionInfo {
  id?: number;
  questionText?: string;
  standardAnswer?: string;
  grade?: number;
  type?: number;
  originName?: string;
  originType?: string;
  locale?: string;
  questionType?: string;
  difficultyLevel?: number;
  creatorId?: string;
  archived?: boolean;
  aiSolve?: boolean;
  createdAt?: string;
  scope?: number;
  version?: number;
  filesJson?: string;
  questionTextEn?: string;
  standardAnswerEn?: string;
}

export interface QuestionModel {
  question?: Question;
  questionInfo: QuestionInfo;
  isBookmark?: boolean;
  isRewardCapped?: boolean;
}

/**
 * 封装通用字段的响应
 */
export interface EltResponseGetQuestionListByTopicResponse {
  /** 业务响应码 */
  code: number;
  /** 响应信息 */
  message: string;
  data?: GetQuestionListByTopicResponse;
  /** 请求时间戳，用于定位问题 */
  timestamp?: string;
}

/**
 * 响应数据
 */
export interface GetQuestionListByTopicResponse {
  questionList: QuestionInfo[][];
}

/**
 * 封装通用字段的响应
 */
export interface EltResponseGetQuestionListByTopicV2Response {
  /** 业务响应码 */
  code: number;
  /** 响应信息 */
  message: string;
  data?: GetQuestionListByTopicV2Response;
  /** 请求时间戳，用于定位问题 */
  timestamp?: string;
}

/**
 * 响应数据
 */
export interface GetQuestionListByTopicV2Response {
  questionList: QuestionInfoExt[];
}

export interface QuestionInfoExt {
  id?: number;
  questionText?: string;
  standardAnswer?: string;
  grade?: number;
  type?: number;
  originName?: string;
  originType?: string;
  locale?: string;
  questionType?: string;
  difficultyLevel?: number;
  creatorId?: string;
  archived?: boolean;
  aiSolve?: boolean;
  createdAt?: string;
  scope?: number;
  version?: number;
  filesJson?: string;
  questionTextEn?: string;
  standardAnswerEn?: string;
  topicIds?: number[];
  topicNames?: string[];
  knowledgePointIds?: number[];
  knowledgeNames?: string[];
}

/**
 * 封装通用字段的响应
 */
export interface EltResponseGetQuestionInfoResponse {
  /** 业务响应码 */
  code: number;
  /** 响应信息 */
  message: string;
  data?: GetQuestionInfoResponse;
  /** 请求时间戳，用于定位问题 */
  timestamp?: string;
}

/**
 * 响应数据
 */
export interface GetQuestionInfoResponse {
  question: QuestionInfo;
  questionLabelList: QuestionLabel[];
}

/**
 * 封装通用字段的响应
 */
export interface EltResponseGetKnowledgePointListResponse {
  /** 业务响应码 */
  code: number;
  /** 响应信息 */
  message: string;
  data?: GetKnowledgePointListResponse;
  /** 请求时间戳，用于定位问题 */
  timestamp?: string;
}

/**
 * 响应数据
 */
export interface GetKnowledgePointListResponse {
  knowledgePoints: QuestionLabel[];
}

/**
 * 封装通用字段的响应
 */
export interface EltResponseGetAllLabelResponse {
  /** 业务响应码 */
  code: number;
  /** 响应信息 */
  message: string;
  data?: GetAllLabelResponse;
  /** 请求时间戳，用于定位问题 */
  timestamp?: string;
}

/**
 * 响应数据
 */
export interface GetAllLabelResponse {
  questionLabels: QuestionLabel[];
}

/**
 * 封装通用字段的响应
 */
export interface EltResponseLeaderboardResponse {
  /** 业务响应码 */
  code: number;
  /** 响应信息 */
  message: string;
  data?: LeaderboardResponse;
  /** 请求时间戳，用于定位问题 */
  timestamp?: string;
}

export interface Leaderboard {
  id?: number;
  leaderboardType?: string;
  studentId?: number;
  schoolName?: string;
  totalKp?: number;
  totalGs?: number;
  totalPoints?: number;
  improvementScore?: number;
  lastMonthAvg?: number;
  currentMonthAvg?: number;
  rankInSchool?: number;
  rankGlobal?: number;
  seasonMonth?: string;
  tier?: string;
}

export type LeaderboardResponseStudentNames = { [key: string]: string };

export type LeaderboardResponseSchoolNamesCn = { [key: string]: string };

/**
 * 响应数据
 */
export interface LeaderboardResponse {
  entries?: Leaderboard[];
  total?: number;
  page?: number;
  size?: number;
  leaderboardType?: string;
  seasonMonth?: string;
  studentNames?: LeaderboardResponseStudentNames;
  schoolNamesCn?: LeaderboardResponseSchoolNamesCn;
}

/**
 * 封装通用字段的响应
 */
export interface EltResponseLeaderboardWinnersResponse {
  /** 业务响应码 */
  code: number;
  /** 响应信息 */
  message: string;
  data?: LeaderboardWinnersResponse;
  /** 请求时间戳，用于定位问题 */
  timestamp?: string;
}

export type LeaderboardWinnersResponseStudentNames = { [key: string]: string };

export type LeaderboardWinnersResponseSchoolNamesCn = { [key: string]: string };

/**
 * 响应数据
 */
export interface LeaderboardWinnersResponse {
  seasonMonth?: string;
  master?: Leaderboard[];
  grit?: Leaderboard[];
  rocket?: Leaderboard[];
  hallOfFame?: Leaderboard[];
  studentNames?: LeaderboardWinnersResponseStudentNames;
  schoolNamesCn?: LeaderboardWinnersResponseSchoolNamesCn;
}

/**
 * 封装通用字段的响应
 */
export interface EltResponseStudentRankResponse {
  /** 业务响应码 */
  code: number;
  /** 响应信息 */
  message: string;
  data?: StudentRankResponse;
  /** 请求时间戳，用于定位问题 */
  timestamp?: string;
}

export type StudentRankResponseStudentNames = { [key: string]: string };

export type StudentRankResponseSchoolNamesCn = { [key: string]: string };

/**
 * 响应数据
 */
export interface StudentRankResponse {
  ranks?: Leaderboard[];
  studentNames?: StudentRankResponseStudentNames;
  schoolNamesCn?: StudentRankResponseSchoolNamesCn;
}

/**
 * Conversation sessions response
 */
export interface ConversationSessionsResponse {
  /** Whether sessions were retrieved successfully */
  success?: boolean;
  /** List of conversation sessions */
  sessions?: SessionInfo[];
}

/**
 * 封装通用字段的响应
 */
export interface EltResponseConversationSessionsResponse {
  /** 业务响应码 */
  code: number;
  /** 响应信息 */
  message: string;
  data?: ConversationSessionsResponse;
  /** 请求时间戳，用于定位问题 */
  timestamp?: string;
}

export interface MessageInfo {
  role?: string;
  content?: string;
  type?: string;
  createdAt?: string;
}

/**
 * List of conversation sessions
 */
export interface SessionInfo {
  sessionId?: string;
  lastMessageAt?: string;
  messages?: MessageInfo[];
}

/**
 * 封装通用字段的响应
 */
export interface EltResponseStudentPointsResponse {
  /** 业务响应码 */
  code: number;
  /** 响应信息 */
  message: string;
  data?: StudentPointsResponse;
  /** 请求时间戳，用于定位问题 */
  timestamp?: string;
}

/**
 * 响应数据
 */
export interface StudentPointsResponse {
  kpAllTime?: number;
  gsAllTime?: number;
  kpCurrentMonth?: number;
  gsCurrentMonth?: number;
  seasonStartDate?: string;
  currentMonth?: string;
  gamificationEnabled?: boolean;
  leaderboardEnabled?: boolean;
}

/**
 * 封装通用字段的响应
 */
export interface EltResponsePointTransactionResponse {
  /** 业务响应码 */
  code: number;
  /** 响应信息 */
  message: string;
  data?: PointTransactionResponse;
  /** 请求时间戳，用于定位问题 */
  timestamp?: string;
}

/**
 * 响应数据
 */
export interface PointTransactionResponse {
  transactions?: PointsSystem[];
  total?: number;
  page?: number;
  size?: number;
}

export interface PointsSystem {
  pointId?: number;
  studentId?: number;
  pointsSource?: string;
  pointsAmount?: number;
  awardedAt?: string;
  description?: string;
  currencyType?: string;
  eventType?: string;
  eventSourceType?: string;
  eventSourceId?: number;
  multiplier?: number;
  difficultyLevel?: number;
  metadata?: string;
  status?: string;
}

/**
 * 封装通用字段的响应
 */
export interface EltResponseMultiplierStatusResponse {
  /** 业务响应码 */
  code: number;
  /** 响应信息 */
  message: string;
  data?: MultiplierStatusResponse;
  /** 请求时间戳，用于定位问题 */
  timestamp?: string;
}

/**
 * 响应数据
 */
export interface MultiplierStatusResponse {
  homeworkComplete?: boolean;
  currentMultiplier?: number;
}

/**
 * 封装通用字段的响应
 */
export interface EltResponseMonthlyAchievementProgressResponse {
  /** 业务响应码 */
  code: number;
  /** 响应信息 */
  message: string;
  data?: MonthlyAchievementProgressResponse;
  /** 请求时间戳，用于定位问题 */
  timestamp?: string;
}

/**
 * 响应数据
 */
export interface MonthlyAchievementProgressResponse {
  totalAssignments?: number;
  onTimeCount?: number;
  perfectCount?: number;
  onTimeEligible?: boolean;
  perfectEligible?: boolean;
  month?: string;
}

/**
 * 响应数据
 */
export interface AdminStudentSearchResponse {
  students?: StudentSummary[];
  total?: number;
  page?: number;
  size?: number;
}

/**
 * 封装通用字段的响应
 */
export interface EltResponseAdminStudentSearchResponse {
  /** 业务响应码 */
  code: number;
  /** 响应信息 */
  message: string;
  data?: AdminStudentSearchResponse;
  /** 请求时间戳，用于定位问题 */
  timestamp?: string;
}

export interface StudentSummary {
  studentId?: number;
  name?: string;
  nameEn?: string;
  email?: string;
  schoolName?: string;
  grade?: number;
  kpAllTime?: number;
  gsAllTime?: number;
}

/**
 * 封装通用字段的响应
 */
export interface EltResponseStudentRewardHistoryResponse {
  /** 业务响应码 */
  code: number;
  /** 响应信息 */
  message: string;
  data?: StudentRewardHistoryResponse;
  /** 请求时间戳，用于定位问题 */
  timestamp?: string;
}

/**
 * 响应数据
 */
export interface StudentRewardHistoryResponse {
  studentId?: number;
  studentName?: string;
  schoolName?: string;
  kpAllTime?: number;
  gsAllTime?: number;
  kpCurrentMonth?: number;
  gsCurrentMonth?: number;
  activeCount?: number;
  lateCount?: number;
  archivedCount?: number;
  voidedCount?: number;
  transactions?: PointsSystem[];
  totalTransactions?: number;
  page?: number;
  size?: number;
}

export interface BonusAwardStatus {
  pointId?: number;
  pointsAmount?: number;
  currencyType?: string;
  awardedAt?: string;
  status?: string;
  metadata?: string;
}

/**
 * 封装通用字段的响应
 */
export interface EltResponseMonthlyAchievementAuditResponse {
  /** 业务响应码 */
  code: number;
  /** 响应信息 */
  message: string;
  data?: MonthlyAchievementAuditResponse;
  /** 请求时间戳，用于定位问题 */
  timestamp?: string;
}

/**
 * 响应数据
 */
export interface MonthlyAchievementAuditResponse {
  studentId?: number;
  studentName?: string;
  studentEmail?: string;
  schoolName?: string;
  month?: string;
  assignedCount?: number;
  completedCount?: number;
  onTimeCount?: number;
  perfectCount?: number;
  onTimeEligible?: boolean;
  perfectEligible?: boolean;
  onTimeBonus?: BonusAwardStatus;
  perfectBonus?: BonusAwardStatus;
  onTimeDiscrepancy?: boolean;
  perfectDiscrepancy?: boolean;
}

/**
 * 封装通用字段的响应
 */
export interface EltResponseListSchoolGamificationStatusResponse {
  /** 业务响应码 */
  code: number;
  /** 响应信息 */
  message: string;
  /** 响应数据 */
  data?: SchoolGamificationStatusResponse[];
  /** 请求时间戳，用于定位问题 */
  timestamp?: string;
}

/**
 * 响应数据
 */
export interface SchoolGamificationStatusResponse {
  id?: number;
  schoolName?: string;
  schoolNameEn?: string;
  gamificationEnabled?: boolean;
  leaderboardEnabled?: boolean;
}

export interface AffectedStudent {
  studentId?: number;
  studentName?: string;
  schoolName?: string;
  recordCount?: number;
}

/**
 * 封装通用字段的响应
 */
export interface EltResponsePreGamificationPreviewResponse {
  /** 业务响应码 */
  code: number;
  /** 响应信息 */
  message: string;
  data?: PreGamificationPreviewResponse;
  /** 请求时间戳，用于定位问题 */
  timestamp?: string;
}

/**
 * 响应数据
 */
export interface PreGamificationPreviewResponse {
  gamificationStartMonth?: string;
  totalRecordsToArchive?: number;
  totalAffectedStudents?: number;
  affectedStudents?: AffectedStudent[];
}

export interface DuplicateGroup {
  studentId?: number;
  pointsSource?: string;
  pointsAmount?: number;
  description?: string;
  currencyType?: string;
  eventType?: string;
  eventSourceType?: string;
  eventSourceId?: number;
  difficultyLevel?: number;
  metadata?: string;
  status?: string;
  count?: number;
  questionInfoId?: number;
  records?: PointsSystem[];
}

/**
 * 响应数据
 */
export interface DuplicateRewardRecordsResponse {
  duplicateGroupCount?: number;
  totalDuplicateRecords?: number;
  duplicateGroups?: DuplicateGroup[];
  overCapPracticeGroupCount?: number;
  overCapPracticeRecordsTotal?: number;
  overCapPracticeGroups?: OverCapPracticeGroup[];
}

/**
 * 封装通用字段的响应
 */
export interface EltResponseDuplicateRewardRecordsResponse {
  /** 业务响应码 */
  code: number;
  /** 响应信息 */
  message: string;
  data?: DuplicateRewardRecordsResponse;
  /** 请求时间戳，用于定位问题 */
  timestamp?: string;
}

export interface OverCapPracticeGroup {
  studentId?: number;
  questionInfoId?: number;
  yearMonth?: string;
  blockedAssignmentIds?: number[];
  recordsToArchive?: number;
  records?: PointsSystem[];
}

/**
 * 封装通用字段的响应
 */
export interface EltResponseListGamificationConfigResponse {
  /** 业务响应码 */
  code: number;
  /** 响应信息 */
  message: string;
  /** 响应数据 */
  data?: GamificationConfigResponse[];
  /** 请求时间戳，用于定位问题 */
  timestamp?: string;
}

/**
 * 响应数据
 */
export interface GamificationConfigResponse {
  id?: number;
  configKey?: string;
  configValue?: string;
  dataType?: string;
  description?: string;
  updatedAt?: string;
}

export type AdminAllLeaderboardsResponseSchoolLeaderboards = {
  [key: string]: SchoolLeaderboards;
};

export type AdminAllLeaderboardsResponseStudentNames = {
  [key: string]: string;
};

export type AdminAllLeaderboardsResponseSchoolNamesCn = {
  [key: string]: string;
};

/**
 * 响应数据
 */
export interface AdminAllLeaderboardsResponse {
  seasonMonth?: string;
  schoolLeaderboards?: AdminAllLeaderboardsResponseSchoolLeaderboards;
  hallOfFame?: HallOfFameEntry[];
  studentNames?: AdminAllLeaderboardsResponseStudentNames;
  schoolNamesCn?: AdminAllLeaderboardsResponseSchoolNamesCn;
}

/**
 * 封装通用字段的响应
 */
export interface EltResponseAdminAllLeaderboardsResponse {
  /** 业务响应码 */
  code: number;
  /** 响应信息 */
  message: string;
  data?: AdminAllLeaderboardsResponse;
  /** 请求时间戳，用于定位问题 */
  timestamp?: string;
}

export interface HallOfFameEntry {
  studentId?: number;
  schoolName?: string;
  totalKp?: number;
  totalGs?: number;
  totalPoints?: number;
  rankGlobal?: number;
}

export interface SchoolLeaderboardEntry {
  studentId?: number;
  schoolName?: string;
  totalPoints?: number;
  totalKp?: number;
  totalGs?: number;
  rankInSchool?: number;
}

export interface SchoolLeaderboards {
  schoolName?: string;
  master?: SchoolLeaderboardEntry[];
  grit?: SchoolLeaderboardEntry[];
  rocket?: SchoolLeaderboardEntry[];
}

/**
 * 封装通用字段的响应
 */
export interface EltResponseGetCurrentTaskResponse {
  /** 业务响应码 */
  code: number;
  /** 响应信息 */
  message: string;
  data?: GetCurrentTaskResponse;
  /** 请求时间戳，用于定位问题 */
  timestamp?: string;
}

/**
 * 响应数据
 */
export interface GetCurrentTaskResponse {
  taskId?: number;
  weekNo?: number;
  leftCandidate?: QuestionCandidateResponse;
  rightCandidate?: QuestionCandidateResponse;
  currentIndex?: number;
  totalTasks?: number;
}

export interface QuestionCandidateResponse {
  id?: number;
  strategy?: string;
  grade?: string;
  difficulty?: string;
  questionType?: string;
  subject?: string;
  unit?: string;
  objective?: string;
  topic?: string;
  questionText?: string;
  questionAns?: string;
}

export interface VerifyStudentsRequest {
  emails: string[];
}

/**
 * 封装通用字段的响应
 */
export interface EltResponseVerifyStudentsResponse {
  /** 业务响应码 */
  code: number;
  /** 响应信息 */
  message: string;
  data?: VerifyStudentsResponse;
  /** 请求时间戳，用于定位问题 */
  timestamp?: string;
}

/**
 * 响应数据
 */
export interface VerifyStudentsResponse {
  emails: string[];
}

export interface VerifyClassroomRequest {
  classnames: string[];
}

/**
 * 响应数据
 */
export interface ClassroomGetStudentsResponse {
  classroomInfoId: number;
  mappingIds: number[];
  students: Student[];
}

/**
 * 封装通用字段的响应
 */
export interface EltResponseClassroomGetStudentsResponse {
  /** 业务响应码 */
  code: number;
  /** 响应信息 */
  message: string;
  data?: ClassroomGetStudentsResponse;
  /** 请求时间戳，用于定位问题 */
  timestamp?: string;
}

export interface Student {
  id?: number;
  sex?: string;
  userState?: string;
  email?: string;
  salt?: string;
  avatar?: string;
  signature?: string;
  name?: string;
  schoolName?: string;
  studentReferenceNumber?: string;
  grade?: number;
  lastLoginTime?: string;
  credits?: number;
  createdAt?: string;
  studentClassNumber?: number;
  studentSchoolNumber?: number;
  nameEn?: string;
  kpAllTime?: number;
  gsAllTime?: number;
  kpCurrentMonth?: number;
  gsCurrentMonth?: number;
  lastMonthAvgScore?: number;
  currentMonthAvgScore?: number;
  seasonStartDate?: string;
}

/**
 * 响应数据
 */
export interface ClassroomGetAllInfoResponse {
  classroomInfoResponseList: ClassroomInfoResponse[];
}

export interface ClassroomInfoResponse {
  id: number;
  name: string;
  studentCount: number;
}

/**
 * 封装通用字段的响应
 */
export interface EltResponseClassroomGetAllInfoResponse {
  /** 业务响应码 */
  code: number;
  /** 响应信息 */
  message: string;
  data?: ClassroomGetAllInfoResponse;
  /** 请求时间戳，用于定位问题 */
  timestamp?: string;
}

/**
 * 响应数据
 */
export interface ClassroomGetAllStudentsResponse {
  students: Student[];
}

/**
 * 封装通用字段的响应
 */
export interface EltResponseClassroomGetAllStudentsResponse {
  /** 业务响应码 */
  code: number;
  /** 响应信息 */
  message: string;
  data?: ClassroomGetAllStudentsResponse;
  /** 请求时间戳，用于定位问题 */
  timestamp?: string;
}

/**
 * 封装通用字段的响应
 */
export interface EltResponseGetStudentAssignmentStatsResponse {
  /** 业务响应码 */
  code: number;
  /** 响应信息 */
  message: string;
  data?: GetStudentAssignmentStatsResponse;
  /** 请求时间戳，用于定位问题 */
  timestamp?: string;
}

/**
 * 响应数据
 */
export interface GetStudentAssignmentStatsResponse {
  studentAssignmentStatList: StudentAssignmentStat[];
}

export interface StudentAssignmentStat {
  student: Student;
  question: Question[];
}

/**
 * 封装通用字段的响应
 */
export interface EltResponseGetStudentMessageRequest {
  /** 业务响应码 */
  code: number;
  /** 响应信息 */
  message: string;
  data?: GetStudentMessageRequest;
  /** 请求时间戳，用于定位问题 */
  timestamp?: string;
}

/**
 * 响应数据
 */
export interface GetStudentMessageRequest {
  studentMessages: StudentMessage[];
}

/**
 * 封装通用字段的响应
 */
export interface EltResponseGetQuizResponse {
  /** 业务响应码 */
  code: number;
  /** 响应信息 */
  message: string;
  data?: GetQuizResponse;
  /** 请求时间戳，用于定位问题 */
  timestamp?: string;
}

/**
 * 响应数据
 */
export interface GetQuizResponse {
  id?: number;
  quiz?: Quiz;
  topicIds?: number[];
  topicNames?: string[];
  questionInfos?: QuestionInfo[];
}

export interface Quiz {
  id?: number;
  title?: string;
  description?: string;
  subject?: string;
  subjectId?: number;
  originName?: string;
  originType?: string;
  teacherId?: number;
  createdAt?: string;
  language?: string;
}

/**
 * 封装通用字段的响应
 */
export interface EltResponseGetQuestionResponse {
  /** 业务响应码 */
  code: number;
  /** 响应信息 */
  message: string;
  data?: GetQuestionResponse;
  /** 请求时间戳，用于定位问题 */
  timestamp?: string;
}

/**
 * 响应数据
 */
export interface GetQuestionResponse {
  questionModel: QuestionModel;
}

export interface Assignment {
  id?: number;
  title?: string;
  description?: string;
  type?: string;
  teacherId?: number;
  classroomSessionId?: string;
  quizId?: number;
  dueDate?: string;
  studentId?: number;
  createdAt?: string;
  archived?: boolean;
}

export interface AssignmentModel {
  assignment: Assignment;
  subject: string;
  subjectId?: number;
  topicList: string[];
  classInfo: Class;
  source?: string;
  teacherName?: string;
}

export interface AssignmentStatsV2 {
  questionStats?: QuestionStats[];
}

export interface Class {
  id?: number;
  name?: string;
  schoolName?: string;
  grade?: number;
  createdAt?: string;
}

/**
 * 封装通用字段的响应
 */
export interface EltResponseGetAssignmentStatsResponse {
  /** 业务响应码 */
  code: number;
  /** 响应信息 */
  message: string;
  data?: GetAssignmentStatsResponse;
  /** 请求时间戳，用于定位问题 */
  timestamp?: string;
}

/**
 * 响应数据
 */
export interface GetAssignmentStatsResponse {
  assignmentList: AssignmentModel[];
  assignmentStatsList: AssignmentStatsV2[];
}

export interface QuestionStats {
  id?: number;
  studentId?: number;
  isCorrectAnswer?: boolean;
  isFirstAttemptCorrect?: boolean;
  isCompleted?: boolean;
  firstAttemptAnswer?: string;
  errorKnowledgePoints: string[];
  answerDuration?: number;
}

/**
 * 封装通用字段的响应
 */
export interface EltResponseGetAssignmentStatusResponse {
  /** 业务响应码 */
  code: number;
  /** 响应信息 */
  message: string;
  data?: GetAssignmentStatusResponse;
  /** 请求时间戳，用于定位问题 */
  timestamp?: string;
}

/**
 * 响应数据
 */
export interface GetAssignmentStatusResponse {
  assignmentStat?: AssignmentStat;
}

export interface AssignmentStats {
  totalCount: number;
  submittedCount: number;
  correctCount: number;
  errorKnowledgePoints: string[];
}

/**
 * 封装通用字段的响应
 */
export interface EltResponseGetAssignmentListResponse {
  /** 业务响应码 */
  code: number;
  /** 响应信息 */
  message: string;
  data?: GetAssignmentListResponse;
  /** 请求时间戳，用于定位问题 */
  timestamp?: string;
}

/**
 * 响应数据
 */
export interface GetAssignmentListResponse {
  assignmentList: AssignmentModel[];
  assignmentStatsList: AssignmentStats[];
}

/**
 * 封装通用字段的响应
 */
export interface EltResponseGetAIQuizResponse {
  /** 业务响应码 */
  code: number;
  /** 响应信息 */
  message: string;
  data?: GetAIQuizResponse;
  /** 请求时间戳，用于定位问题 */
  timestamp?: string;
}

/**
 * 响应数据
 */
export interface GetAIQuizResponse {
  topicIds?: number[];
  questionInfoList: QuestionInfo[][];
}

/**
 * 封装通用字段的响应
 */
export interface EltResponseGetAIQuizV2Response {
  /** 业务响应码 */
  code: number;
  /** 响应信息 */
  message: string;
  data?: GetAIQuizV2Response;
  /** 请求时间戳，用于定位问题 */
  timestamp?: string;
}

/**
 * 响应数据
 */
export interface GetAIQuizV2Response {
  questionInfoList: QuestionInfoExt[];
}

export type VerifyRecaptchaParams = {
  "g-recaptcha-response": string;
};

export type DeleteAccountParams = {
  email: string;
};

export type SetSchoolPressParams = {
  schoolName: string;
};

export type SetSchoolPressBody = { [key: string]: string[] };

export type OcrQuestionBody = {
  image: Blob;
};

export type ImportQuestionBankBody = {
  model: string;
  images: Blob[];
};

export type GetSchoolPressParams = {
  schoolName: string;
};

export type EditQuestionInfoBody = {
  model: string;
  questionImages?: Blob[];
  standardAnswerImages?: Blob[];
  answerImages?: Blob[];
};

export type CreateQuestionInfoBody = {
  model: string;
  questionImages?: Blob[];
  standardAnswerImages?: Blob[];
  answerImages?: Blob[];
};

export type ImportQuestionCandidatesBody = {
  file: Blob;
};

export type ImportAbTasksBody = {
  file: Blob;
};

export type DeleteSchoolParams = {
  schoolName: string;
};

export type SubmitDraftBody = {
  model: string;
  images?: Blob[];
};

export type SubmitAnswerBody = {
  model: string;
  images?: Blob[];
};

export type SubmitAnswerTextBody = {
  model: string;
};

export type AnswerStartParams = {
  questionId: number;
};

export type AnswerEndParams = {
  questionId: number;
};

export type Generate200 = { [key: string]: { [key: string]: unknown } };

export type RequestCaptchaParams = {
  nonce: string;
};

export type GetSaltParams = {
  email: string;
};

export type QuerySurveyParams = {
  userId: number;
  surveyId: number;
};

export type QuerySurveyV2Params = {
  userId: number;
  surveyId: number;
};

export type ListTeachersBySchoolParams = {
  schoolName: string;
};

export type ListGranteesParams = {
  assignmentId: number;
};

export type CheckPulseItemParams = {
  studentId: number;
  assignmentId: number;
  type?: string;
};

export type GetTopicListParams = {
  teacherId: number;
  schoolName: string;
};

export type GetTopicListByQuestionInfoIdListParams = {
  questionInfoIdList: number[];
};

export type GetRecapQuestionListParams = {
  studentId: number;
  lastDayCount: number;
  questionCount?: number;
};

export type GetQuestionListByTopicParams = {
  topicIds: number[];
  libraryNames: string[];
  includePress?: boolean;
};

export type GetQuestionListByTopicV3Params = {
  topicIds: number[];
  knowledgePointIds: number[];
  libraryNames: string[];
  includePress?: boolean;
  language: string;
};

export type GetQuestionListByTopicV2Params = {
  topicIds: number[];
  libraryNames: string[];
  includePress?: boolean;
  language: string;
};

export type GetQuestionInfoParams = {
  questionId: number;
};

export type GetKnowledgePointListParams = {
  teacherId: number;
  schoolName: string;
  topicId: string;
};

export type GetFreestyleQuestionListParams = {
  studentId: number;
  topicIds: number[];
  libraryNames: string[];
  questionCount?: number;
  minDifficulty?: number;
  maxDifficulty?: number;
};

export type GetFreestyleQuestionListV3Params = {
  studentId: number;
  topicIds: number[];
  knowledgePointIds: number[];
  libraryNames: string[];
  questionCount?: number;
  minDifficulty?: number;
  maxDifficulty?: number;
};

export type GetExtensionQuestionListParams = {
  studentId: number;
  assignmentId: number;
  questionCount?: number;
};

export type GetAllLabelParams = {
  type: string;
};

export type GetRocketLeaderboardParams = {
  /**
   * Month (YYYY-MM)
   */
  month?: string;
  /**
   * Page number
   */
  page?: number;
  /**
   * Page size
   */
  size?: number;
};

export type GetPreviousMonthWinnersParams = {
  /**
   * Month (YYYY-MM)
   */
  month: string;
};

export type GetMyRanksParams = {
  /**
   * Month (YYYY-MM)
   */
  month?: string;
};

export type GetMasterLeaderboardParams = {
  /**
   * Month (YYYY-MM)
   */
  month?: string;
  /**
   * Page number
   */
  page?: number;
  /**
   * Page size
   */
  size?: number;
};

export type GetHallOfFameLeaderboardParams = {
  /**
   * Page number
   */
  page?: number;
  /**
   * Page size
   */
  size?: number;
};

export type GetGritLeaderboardParams = {
  /**
   * Month (YYYY-MM)
   */
  month?: string;
  /**
   * Page number
   */
  page?: number;
  /**
   * Page size
   */
  size?: number;
};

export type GetPointHistoryParams = {
  /**
   * Page number
   */
  page?: number;
  /**
   * Page size
   */
  size?: number;
};

export type GetMonthlyProgressParams = {
  /**
   * Month (YYYY-MM format)
   */
  month?: string;
};

export type SearchStudentsParams = {
  /**
   * Student name (Chinese or English, partial match)
   */
  name?: string;
  /**
   * School name (partial match)
   */
  schoolName?: string;
  /**
   * Page number
   */
  page?: number;
  /**
   * Page size
   */
  size?: number;
};

export type GetStudentRewardHistoryParams = {
  /**
   * Student email
   */
  email: string;
  /**
   * Page number
   */
  page?: number;
  /**
   * Page size
   */
  size?: number;
};

export type GetStudentMonthlyAchievementAuditParams = {
  /**
   * Student email
   */
  email: string;
  /**
   * Month (YYYY-MM); defaults to current month
   */
  month?: string;
};

export type GetAdminAllLeaderboardsParams = {
  /**
   * Month (YYYY-MM)
   */
  month?: string;
};

export type VerifyClassStudentsParams = {
  model: VerifyStudentsRequest;
};

export type VerifyClassroomParams = {
  model: VerifyClassroomRequest;
};

export type GetClassStudentsParams = {
  classroomInfoId: number;
};

export type GetInfoParams = {
  schoolName: string;
  teacherId: number;
};

export type GetAllStudentsParams = {
  schoolName: string;
};

export type GetAllClassInfoParams = {
  schoolName: string;
};

export type GetStudentPracticeStatsParams = {
  classInfoId: number;
};

export type GetStudentMessageParams = {
  questionId?: number;
  type?: number;
};

export type GetStudentAssignmentStatsParams = {
  assignmentId: number;
  classInfoId: number;
};

export type GetQuizParams = {
  quizId: number;
};

export type GetQuestionParams = {
  studentId: number;
  questionId: number;
};

export type GetQuestionListParams = {
  studentId: number;
  assignmentId: number;
  newest: boolean;
};

export type GetAssignmentStatsByTeacherParams = {
  teacherId: number;
};

export type GetAssignmentStatsByTeacherV2Params = {
  source?: string;
};

export type GetAssignmentStatParams = {
  assignmentId: number;
  studentId: number;
};

export type GetAssignmentListByTeacherParams = {
  teacherId: number;
};

export type GetAssignmentListByTeacherV2Params = {
  source?: string;
};

export type GetAssignmentListByStudentParams = {
  studentId: number;
  type: string;
};

export type GetAIQuizParams = {
  topicIds: number[];
  libraryNames: string[];
  subject: string;
  mcqCount: number;
  frqCount: number;
  bfqCount: number;
  minDifficulty: number;
  maxDifficulty: number;
};

export type GetAIQuizV3Params = {
  topicIds: number[];
  knowledgePointIds: number[];
  libraryNames: string[];
  language: string;
  mcqCount: number;
  frqCount: number;
  bfqCount: number;
  minDifficulty: number;
  maxDifficulty: number;
};

export type GetAIQuizV2Params = {
  topicIds: number[];
  libraryNames: string[];
  language: string;
  subject: string;
  mcqCount: number;
  frqCount: number;
  bfqCount: number;
  minDifficulty: number;
  maxDifficulty: number;
};

export type ClearSurveyParams = {
  userId: number;
  surveyId: number;
};

export type ClearSurveyBySchoolParams = {
  schoolName: string;
};
